import React from 'react'
import "../pages/Sidebar.css"

const CountPost = () => {
  return (
    <div className="box">
    <h3>54</h3>
    <span>Posts</span>
  </div>
  )
}

export default CountPost